import React from "react";
import ReactSlider from "react-slider";
import $ from "jquery";
import _ from "lodash";
import {
  deleteMavImage,
  getUsers,
  setUser,
  getretrieveMavImages,
} from "../modules/Admin";
import { showSpinner, closeSpinner, modal, confirm } from "../modules/Dialogs";
import {
  mavBaseLocationNotFound,
  sessionExpired,
  adminSaveChangesConfirm,
  defaultAvatarBase64,
  stripeConnectActive,
  adminMavWillCreateStripe,
  adminMavCannotPreactivate,
  adminMavCannotReset,
  serverUrl,
  userImagesFolder,
  imageFormat,
  defaultAvatarImage,
  defaultMessagesFilter,
  CDN,
} from "../config/GeneralConfig";
import { addressAutoComplete } from "../modules/Geolocation";
import { toScreen } from "../modules/Routing";
import AuditNotes from "./AuditNotes";

import { getCounties, getCities } from "../modules/CountiesAndCities";
import PropTypes from "prop-types";
import withNavigate from "./withNavigate";
import moment from "moment-timezone";

class Mav extends React.Component {
  constructor(props) {
    super(props);

    this.updateNotes = this.updateNotes.bind(this);
    this.addressAutoComplete = this.addressAutoComplete.bind(this);
    this.addressAutoComplete_done = this.addressAutoComplete_done.bind(this);
    this.renderMyAddresses = this.renderMyAddresses.bind(this);
    this.checkAddress = this.checkAddress.bind(this);
    this.getMav = this.getMav.bind(this);
    this.getMav_done = this.getMav_done.bind(this);
    this.getMavImages = this.getMavImages.bind(this);
    this.getMavImages_done = this.getMavImages_done.bind(this);
    this.renderQuotes = this.renderQuotes.bind(this);
    this.saveMav = this.saveMav.bind(this);
    this.saveMav_done = this.saveMav_done.bind(this);
    this.deleteMavImage = this.deleteMavImage.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.deleteMavAvatar = this.deleteMavAvatar.bind(this);
    this.discardChanges = this.discardChanges.bind(this);
    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.getCounties = this.getCounties.bind(this);
    this.getCounties_done = this.getCounties_done.bind(this);
    this.checkCounty = this.checkCounty.bind(this);
    this.countyAutoComplete = this.countyAutoComplete.bind(this);
    this.renderCounties = this.renderCounties.bind(this);
    this.getCities = this.getCities.bind(this);
    this.getCities_done = this.getCities_done.bind(this);
    this.checkCity = this.checkCity.bind(this);
    this.cityAutoComplete = this.cityAutoComplete.bind(this);
    this.renderCities = this.renderCities.bind(this);
    this.setLoader = this.setLoader.bind(this);
    this.runMavFetchCompleted = this.runMavFetchCompleted.bind(this);
    this.handleConfirmBan = this.handleConfirmBan.bind(this);
    this.handleCancelBan = this.handleCancelBan.bind(this);

    this.state = {
      originalStatus: "",
      findAddressStatus: "",
      mav: {
        _id: "",
        short_id: "",
        notes: [],
        accountInfo: {
          username: "",
          drivingLicence: "",
          licenceCheckCode: "",
          companyName: "",
          vatNumber: "",
          wasteHandlingLicence: "",
          wasteHandlingLicenceCopy: "",
          publicLiabilityInsurance: false,
          goodsInTransitInsurance: false,
          generalVanInsurance: false,
          firstname: "",
          surname: "",
          telephone: "",
          email: "",
          avatar: "",
          terms: false,
          settings: {
            emailnotifications: false,
            holidaymode: false,
            marketingnotifications: false,
            pushnotifications: false,
          },
          baseLocation: {
            homeaddress: {
              googleValidated: "",
              placeId: "",
              formattedAddress: "",
              postCode: "",
              addressLine1: "",
              addressLine2: "",
              cityName: "",
              countyName: "",
              countryName: "",
            },
            radius: 50,
          },
        },
        earlyAdopter: "",
        hiddenFromApi: "",
        stripeAccountId: "",
        userType: "",
        status: "",
        quotes: {},

        // New Fields Added for Mav
        //================================================================
        vanMake: "",
        vanModel: "",
        vanYear: "",
        vanRegNumber: "",
        vanStickers: false,
        tshirtSize: "",
        utilitybillCopy: "",
        utilitybillCopyData: "",
        vaninsuranceCopy: "",
        vaninsuranceCopyData: "",
        wasteHandlingLicenceCopy: "",
        wasteHandlingLicenceCopyData: "",
      },
      addressSuggestions: {
        homeaddress: {},
      },
      countiesFound: [],
      citiesFound: [],
      loaders: {
        baseLocation: false,
        city: false,
        postCode: false,
      },
      showModal: false,
      jobs: [
        {
          id: 1,
          from: "123 Road way, Manchester",
          to: "15 Closed lane, York",
          date: "23 Mar 2024",
          time: "15:30",
          price: "£250",
        },
        {
          id: 2,
          from: "123 Road way, Manchester",
          to: "15 Closed lane, York",
          date: "23 Mar 2024",
          time: "15:30",
          price: "£180",
        },
      ],
      mavImages: null,
    };
  }

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function () {
    };
  }

  handleFileSelect = (event) => {
    const target = event.target;
    let stateName = target.name.replace("Picker", "");
    let dataStateName = target.name.replace("Picker", "Data");
    let file = event.target.files[0];

    if (!file) return;

    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
    const MAX_SIZE_MB = 10;

    if (!ALLOWED_TYPES.includes(file.type)) {
      modal('Only JPG, PNG, GIF, and PDF files are accepted.');
      event.target.value = '';
      return;
    }

    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      modal(`File must be smaller than ${MAX_SIZE_MB} MB.`);
      event.target.value = '';
      return;
    }

    let fileBase64 = "";
    this.getBase64(file, (result) => {
      fileBase64 = result;

      this.setState({
        ...this.state,
        mav: {
          ...this.state.mav,
          [stateName]: file.name,
          [dataStateName]: fileBase64,
        },
      });
    });
  };

  setLoader(loaderName, flag) {
    this.setState((prevState) => ({
      ...prevState,
      loaders: {
        ...prevState.loaders,
        [loaderName]: flag,
      },
    }));
  }

  updateNotes(newNotes, theCallback) {
    if (!_.isEqual(newNotes, this.state.mav.notes)) {
      this.setState(
        {
          ...this.state,
          mav: {
            ...this.state.mav,
            notes: newNotes,
          },
        },
        theCallback
      );
    } else if (theCallback) {
      theCallback();
    }
  }

  handleSliderChange(value) {
    this.setState(
      {
        ...this.state,
        mav: {
          ...this.state.mav,
          accountInfo: {
            ...this.state.mav.accountInfo,
            baseLocation: {
              ...this.state.mav.accountInfo.baseLocation,
              radius: value,
            },
          },
        },
      },
      () => {}
    );
  }

  discardChanges(event) {
    if (event) {
      event.preventDefault();
    }

    //this.getMav();

    toScreen(false, this.props.navigate, "/mavs");
  }

  addressAutoComplete(event, addressTarget) {
    this.setLoader("baseLocation", true);

    try {
      if (event) {
        event.preventDefault();
      }

      if (
        this.state.findAddressStatus ==
          "" /*&& this.state.mav.accountInfo.baseLocation[addressTarget].googleValidated==''*/ &&
        this.state.mav.accountInfo.baseLocation[addressTarget]
          .formattedAddress != "" &&
        addressTarget === "homeaddress"
      ) {
        setTimeout(() => {
          var theAddress = {
            addressTarget: addressTarget,
            theAddress: {
              ...this.state.mav.accountInfo.baseLocation[addressTarget],
            },
          };

          addressAutoComplete(theAddress, this.addressAutoComplete_done);
        }, 100);
      } else {
        this.setLoader("baseLocation", false);
      }
    } catch (error) {
      this.setLoader("baseLocation", false);
    }
  }

  addressAutoComplete_done(resStatus, responseString, resJson) {
    if (resStatus == "400" || resStatus == 400) {
      this.setState({
        ...this.state,
        addressSuggestions: {
          homeaddress: {},
        },
      });
    } else if (resStatus == 200) {
      this.setState({
        ...this.state,
        addressSuggestions: {
          ...this.state.addressSuggestions,
          [resJson.addressTarget]: resJson.predictions,
        },
      });
    }
    this.setLoader("baseLocation", false);
  }

  renderMyAddresses(key, addressTarget) {
    const address = this.state.addressSuggestions[addressTarget][key];
    return <option value={address.description} key={key} />;
  }

  checkAddress(event, addressTarget) {
    event.preventDefault();

    if (
      this.state.mav.accountInfo.baseLocation.homeaddress.placeId == "" ||
      this.state.mav.accountInfo.baseLocation.homeaddress.googleValidated !=
        "passed"
    ) {
      this.setState(
        {
          ...this.state,
          mav: {
            ...this.state.mav,
            accountInfo: {
              ...this.state.mav.accountInfo,
              baseLocation: {
                ...this.state.mav.accountInfo.baseLocation,
                homeaddress: {
                  ...this.state.mav.accountInfo.baseLocation.homeaddress,
                  googleValidated: "",
                  placeId: "",
                  formattedAddress: "",
                  addressGeometry: {
                    coordinates: [0, 0],
                    type: "Point",
                  },
                },
              },
            },
          },
        },
        () => {
          modal(mavBaseLocationNotFound);
        }
      );
    }
  }

  getMav(event) {
    showSpinner();

    if (event) {
      event.preventDefault();
    }

    const theUser = {
      accountInfo: {
        username: this.props.userDetails.accountInfo.username,
        email: this.props.userDetails.accountInfo.email,
      },
      user: this.props.mavId ?? window.location.pathname?.split("/")[2],
      userType: "mav",
    };

    getUsers(theUser, this.getMav_done, this.props.userDetails.jwttoken);
  }

  getMav_done(resStatus, responseString, resJson) {
    closeSpinner();

    if (resStatus == 401) {
      modal(sessionExpired);
      toScreen(false, this.props.navigate, "/logout");
    } else if (resStatus == "400") {
      modal(responseString);

      toScreen(false, this.props.navigate, "/mavs");
    } else if (resStatus == 200) {
      if (resJson.theUsers && resJson.theUsers["0"]) {
        if (
          !resJson.theUsers["0"].accountInfo.baseLocation ||
          !resJson.theUsers["0"].accountInfo.baseLocation.homeaddress ||
          !resJson.theUsers["0"].accountInfo.baseLocation.homeaddress
            .formattedAddress
        ) {
          resJson.theUsers["0"].accountInfo.baseLocation = {
            homeaddress: {
              googleValidated: "",
              placeId: "",
              formattedAddress: "",
            },
          };
        }

        if (!resJson.theUsers["0"].accountInfo.baseLocation.radius) {
          resJson.theUsers["0"].accountInfo.baseLocation.radius = 50;
        }

        this.setState(
          {
            ...this.state,
            originalStatus: resJson.theUsers["0"].status,
            mav: resJson.theUsers["0"],
          },
          () => {
            this.getMavImages(
              resJson.theUsers["0"]._id,
              resJson.theUsers["0"]._id
            );
            this.runMavFetchCompleted();
          }
        );
      } else {
        modal("MAV user details not found", "Something went wrong!", () =>
          window.history.back()
        );
      }
    }
  }

  getMavImages(userId) {
    showSpinner();
    const queryParams = {
      imageType: "profile",
      userId: userId,
    };

    getretrieveMavImages(
      queryParams,
      this.getMavImages_done,
      this.props.userDetails.jwttoken
    );
  }

  getMavImages_done(resStatus, responseString, resJson) {
    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, this.props.navigate, "/logout");
    } else if (resStatus == "400") {
      modal(responseString);
    } else if (resStatus === 200) {
      this.setState({
        ...this.state,
        mavImages: resJson?.data,
      });
    }
  }

  runMavFetchCompleted() {
    this.getCounties();
    this.getCities();
  }

  saveMav(event) {
    if (event) {
      event.preventDefault();
    }

    confirm(false, adminSaveChangesConfirm, "Cancel", "Save", () => {
      showSpinner();

      var theUser = {
        accountInfo: {
          username: this.props.userDetails.accountInfo.username,
          email: this.props.userDetails.accountInfo.email,
        },
        user: {
          _id: this.state.mav._id,
          short_id: this.state.mav.short_id,
          notes: this.state.mav.notes,
          accountInfo: {
            username: this.state.mav.accountInfo.username,
            drivingLicence: this.state.mav.accountInfo.drivingLicence,
            licenceCheckCode: this.state.mav.accountInfo.licenceCheckCode,
            publicLiabilityInsurance:
              this.state.mav.accountInfo.publicLiabilityInsurance,
            goodsInTransitInsurance:
              this.state.mav.accountInfo.goodsInTransitInsurance,
            generalVanInsurance: this.state.mav.accountInfo.generalVanInsurance,
            firstname: this.state.mav.accountInfo.firstname,
            surname: this.state.mav.accountInfo.surname,
            telephone: this.state.mav.accountInfo.telephone,
            email: this.state.mav.accountInfo.email,
            baseLocation: {
              homeaddress: {
                googleValidated:
                  this.state.mav.accountInfo.baseLocation.homeaddress
                    .googleValidated,
                placeId:
                  this.state.mav.accountInfo.baseLocation.homeaddress.placeId,
                formattedAddress:
                  this.state.mav.accountInfo.baseLocation.homeaddress
                    .formattedAddress,
                postCode:
                  this.state.mav.accountInfo.baseLocation.homeaddress.postCode,
                addressLine1:
                  this.state.mav.accountInfo.baseLocation.homeaddress
                    .addressLine1,
                addressLine2:
                  this.state.mav.accountInfo.baseLocation.homeaddress
                    .addressLine2,
                cityName:
                  this.state.mav.accountInfo.baseLocation.homeaddress.cityName,
                countyName:
                  this.state.mav.accountInfo.baseLocation.homeaddress
                    .countyName,
              },
              radius: this.state.mav.accountInfo.baseLocation.radius,
            },
            settings: {
              emailnotifications:
                this.state.mav.accountInfo.settings.emailnotifications,
              holidaymode: this.state.mav.accountInfo.settings.holidaymode,
              marketingnotifications:
                this.state.mav.accountInfo.settings.marketingnotifications,
              pushnotifications:
                this.state.mav.accountInfo.settings.pushnotifications,
            },
          },
          earlyAdopter: this.state.mav.earlyAdopter,
          hiddenFromApi: this.state.mav.hiddenFromApi,
          userType: this.state.mav.userType,
          status: this.state.mav.status,
          vanMake: this.state.mav.vanMake,
          vanModel: this.state.mav.vanModel,
          vanYear: this.state.mav.vanYear,
          vanRegNumber: this.state.mav.vanRegNumber,
          vanStickers: this.state.mav.vanStickers,
          tshirtSize: this.state.mav.tshirtSize,
          utilitybillCopy: this.state.mav.utilitybillCopy,
          utilitybillCopyData: this.state.mav.utilitybillCopyData,
          vaninsuranceCopy: this.state.mav.vaninsuranceCopy,
          vaninsuranceCopyData: this.state.mav.vaninsuranceCopyData,
          wasteHandlingLicenceCopy: this.state.mav.wasteHandlingLicenceCopy,
          wasteHandlingLicenceCopyData:
            this.state.mav.wasteHandlingLicenceCopyData,
        },
      };

      //if(this.state.mav.accountInfo.companyName!=''){
      theUser.user.accountInfo.companyName =
        this.state.mav.accountInfo.companyName;
      //}

      //if(this.state.mav.accountInfo.vatNumber!=''){
      theUser.user.accountInfo.vatNumber = this.state.mav.accountInfo.vatNumber;
      //}

      //if(this.state.mav.accountInfo.wasteHandlingLicence!=''){
      theUser.user.accountInfo.wasteHandlingLicence =
        this.state.mav.accountInfo.wasteHandlingLicence;
      //}

      if (this.state.mav.accountInfo.avatar == "") {
        theUser.user.accountInfo.avatar = defaultAvatarBase64;
      }

      setUser(theUser, this.saveMav_done, this.props.userDetails.jwttoken);
    });
  }

  saveMav_done(resStatus, responseString, resJson) {
    closeSpinner();

    if (resStatus == 401) {
      modal(sessionExpired);
      toScreen(false, this.props.navigate, "/logout");
    } else if (resStatus == "400") {
      modal(responseString);
    } else if (resStatus == 200) {
      modal("Changes successfully saved", false, () => {
        toScreen(false, this.props.navigate, "/mavs");
      });
    }
  }

  deleteMavImage = (event, imageKey) => {
    if (event) {
      event.preventDefault();
    }

    // Show confirmation dialog
    confirm(
      false,
      "Are you sure you want to delete this image?",
      "Cancel",
      "Delete",
      () => {
        deleteMavImage(
          {
            images: [
              {
                imageKey: imageKey,
                imageType: "profile"
              }
            ],
          },
          (resStatus, responseString, resJson) => {
            if (resStatus === 401) {
              modal(sessionExpired);
              toScreen(false, this.props.navigate, "/logout");
            } else if (resStatus === 400) {
              modal(responseString);
            } else if (resStatus === 200) {
              this.setState({
                ...this.state,
                mavImages: null,
              });
              modal("Image deleted successfully");
            }
          },
          this.props.userDetails.jwttoken
        );
      }
    );
  };
  renderQuotes(key) {
    const quote = this.state.mav.quotes[key];

    return (
      <div className="c-list-entry" key={key}>
        <div
          className={`c-list-entry__rating ${
            quote?.status === "open" && "text-gray"
          } ${quote?.status === "complete" && "text-success"}
         ${quote?.status === "paid" && "text-success"} ${
            quote?.status === "closed" && "text-yellow"
          }`}
        >
          {quote?.status
            ? quote.status.charAt(0).toUpperCase() + quote.status.slice(1)
            : "N/A"}
        </div>
        <div className="c-list-entry__amount">
          <strong> &pound;{quote.quoteSpec?.price}</strong>
        </div>
        <div className="c-list-entry__created">
          <span className="u-before-icon-calendar2">
            &nbsp;&nbsp;
            {moment(quote?.creationDate)
              ?.tz("Europe/London")
              ?.format("DD MMM YYYY")}
          </span>
          <br />
          <span className="u-before-icon-clock">
            &nbsp;&nbsp;
            {moment(quote?.creationDate)?.tz("Europe/London")?.format("hh:mm ")}
          </span>
        </div>
        <div className="c-list-entry__btn pr-15">
          <button
            type="button"
            className="c-btn c-btn--teal c-btn--small me-0"
            onClick={(e) =>
              toScreen(e, this.props.navigate, "/job/" + quote?.job?.short_id)
            }
          >
            View Job
          </button>
        </div>
        <div className="c-list-entry__rating ml-32 text-capitalize">
          <strong>{quote?.job?.jobSpec?.serviceType ?? "-"}</strong>
        </div>
        <div className="c-list-entry__created">
          <span className="u-before-icon-calendar2">
            &nbsp;&nbsp;
            {moment(quote?.job?.jobSpec?.dateAndTime?.standardDate)
              ?.tz("Europe/London")
              ?.format("DD MMM YYYY")}
          </span>
          <br />
          <span className="u-before-icon-clock">
            &nbsp;&nbsp;
            {moment(quote?.job?.jobSpec?.dateAndTime?.standardDate)
              ?.tz("Europe/London")
              ?.format("hh:mm ")}
          </span>
        </div>
        <div className="c-list-entry__location">
          <span className="u-before-icon-location text-capitalize">
            &nbsp;&nbsp;
            {quote?.job?.originAddress?.townCityName ||
              quote?.job?.originAddress?.regionName ||
              quote?.job?.originAddress?.formattedAddress}
            {quote?.job?.jobSpec?.serviceType != "dispose" ? "→" : null}
            {quote?.job?.destinationAddress?.townCityName ||
              quote?.job?.destinationAddress?.regionName ||
              quote?.job?.destinationAddress?.formattedAddress ||
              ""}
          </span>
        </div>

        <div className="c-list-entry__created">
          <span className="u-before-icon-calendar2">
            &nbsp;&nbsp;
            {moment(quote?.job?.creationDate)
              ?.tz("Europe/London")
              ?.format("DD MMM YYYY")}
          </span>
          <br />
          <span className="u-before-icon-clock">
            &nbsp;&nbsp;
            {moment(quote?.job?.creationDate)
              ?.tz("Europe/London")
              ?.format("hh:mm ")}
          </span>
        </div>
        <div className="c-list-entry__btn">
          <button
            type="button"
            className="c-btn c-btn--teal c-btn--small me-0"
            onClick={(e) =>
              toScreen(e, this.props.navigate, "/quote/" + quote.short_id)
            }
          >
            View Quote
          </button>
        </div>
      </div>
    );
  }

  getCounties(event) {
    if (event) {
      event.preventDefault();
    }

    getCounties(this.getCounties_done);
  }

  getCounties_done(resStatus, responseString, resJson) {
    try {
      let varCountiesFound = [];

      if (resStatus == "400" || resStatus == 400) {
        varCountiesFound = [];
      } else if (resStatus == 200) {
        varCountiesFound = resJson.counties;
      }

      this.setState({
        ...this.state,
        countiesFound: varCountiesFound,
      });
    } catch (error) {
    }
  }

  checkCounty(event, target) {
    if (event) {
      event.preventDefault();
    }

    if (
      this.state.mav.accountInfo.baseLocation &&
      this.state.mav.accountInfo.baseLocation.homeaddress &&
      this.state.mav.accountInfo.baseLocation.homeaddress.countyName &&
      this.state.mav.accountInfo.baseLocation.homeaddress.countyName != ""
    ) {
      let strCountyName =
        this.state.mav.accountInfo.baseLocation.homeaddress.countyName;

      const matchedCounties = this.state.countiesFound.filter(function (
        county
      ) {
        return county.county == strCountyName;
      });

      if (!matchedCounties || matchedCounties.length == 0) {
        this.setState(
          {
            ...this.state,
            mav: {
              ...this.state.mav,
              accountInfo: {
                ...this.state.mav.accountInfo,
                baseLocation: {
                  ...this.state.mav.accountInfo.baseLocation,
                  homeaddress: {
                    ...this.state.mav.accountInfo.baseLocation.homeaddress,
                    countyName: "",
                  },
                },
              },
            },
          },
          () => {
            modal("County not found ");
          }
        );
      } else {
        this.getCities();
      }
    }
  }

  countyAutoComplete(event, stateName) {
    if (event) {
      event.preventDefault();
    }
  }

  renderCounties(key) {
    const county = this.state.countiesFound[key];

    return <option value={county.county} key={key} />;
  }

  getCities() {
    this.setLoader("city", true);

    if (
      this.state.mav.accountInfo.baseLocation &&
      this.state.mav.accountInfo.baseLocation.homeaddress &&
      this.state.mav.accountInfo.baseLocation.homeaddress.countyName &&
      this.state.mav.accountInfo.baseLocation.homeaddress.countyName != ""
    ) {
      let strCountyName =
        this.state.mav.accountInfo.baseLocation.homeaddress.countyName;
      getCities(strCountyName, this.getCities_done);
    } else {
      this.setLoader("city", false);
    }
  }

  getCities_done(resStatus, responseString, resJson) {
    try {
      let varCitiesFound = [];

      if (resStatus == "400" || resStatus == 400) {
        varCitiesFound = [];
      } else if (resStatus == 200) {
        varCitiesFound = resJson.cities;
      }
      this.setState({
        ...this.state,
        citiesFound: varCitiesFound,
      });
      this.setLoader("city", false);
    } catch (error) {
      this.setLoader("city", false);
    }
  }

  checkCity(event, target) {
    if (event) {
      event.preventDefault();
    }

    if (
      this.state.mav.accountInfo.baseLocation &&
      this.state.mav.accountInfo.baseLocation.homeaddress &&
      this.state.mav.accountInfo.baseLocation.homeaddress.cityName &&
      this.state.mav.accountInfo.baseLocation.homeaddress.cityName != ""
    ) {
      let strCityName =
        this.state.mav.accountInfo.baseLocation.homeaddress.cityName;

      const matchedCities = this.state.citiesFound.filter(function (city) {
        return city == strCityName;
      });

      if (!matchedCities || matchedCities.length == 0) {
        this.setState(
          {
            ...this.state,
            mav: {
              ...this.state.mav,
              accountInfo: {
                ...this.state.mav.accountInfo,
                baseLocation: {
                  ...this.state.mav.accountInfo.baseLocation,
                  homeaddress: {
                    ...this.state.mav.accountInfo.baseLocation.homeaddress,
                    cityName: "",
                  },
                },
              },
            },
          },
          () => {
            modal("City not found ");
          }
        );
      }
    }
  }

  cityAutoComplete(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.state.citiesFound && this.state.citiesFound.length == 0) {
      this.getCities();
    }
  }

  renderCities(key) {
    const city = this.state.citiesFound[key];

    return <option value={city} key={key} />;
  }

  handleInputChange(event, theCallback) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    var oldValue;

    const inputChangeCallback = () => {
      if (
        stripeConnectActive &&
        name === "mav.status" &&
        value === "active" &&
        (!this.state.mav.stripeAccountId ||
          this.state.mav.stripeAccountId == "")
      ) {
        modal(adminMavWillCreateStripe, "Stripe Account Notice");
      } else {
        if (name === "mav.status" && value === "blocked") {
          this.setState({ showModal: true });
        } else {
          if (
            name == "mav.accountInfo.baseLocation.homeaddress.formattedAddress"
          ) {
            var newPlaceId = "";
            var newGoogleValidated = "";

            _.forEach(
              this.state.addressSuggestions.homeaddress,
              (valueA, key) => {
                if (valueA.description == value) {
                  newPlaceId = valueA.place_id;
                  newGoogleValidated = "passed";
                }
              }
            );

            this.setState(
              {
                ...this.state,
                mav: {
                  ...this.state.mav,
                  accountInfo: {
                    ...this.state.mav.accountInfo,
                    baseLocation: {
                      ...this.state.mav.accountInfo.baseLocation,
                      homeaddress: {
                        ...this.state.mav.accountInfo.baseLocation.homeaddress,
                        googleValidated: newGoogleValidated,
                        placeId: newPlaceId,
                        addressGeometry: {
                          coordinates: [0, 0],
                          type: "Point",
                        },
                      },
                    },
                  },
                },
              },
              theCallback
            );
          } else if (theCallback) {
            theCallback();
          }
        }
      }
    };

    // Handle special case for status changes
    if (name === "mav.status") {
      // Update UI immediately when changing status
      this.setState(
        {
          mav: {
            ...this.state.mav,
            status: value,
          },
        },
        () => {
          if (value === "active" && oldValue === "delete") {
          }
          inputChangeCallback();
        }
      );
      return; // Exit early since we've handled the status change
    } else if (
      name === "mav.accountInfo.settings.pushnotifications" ||
      name === "mav.accountInfo.settings.emailnotifications" ||
      name === "mav.accountInfo.settings.marketingnotifications" ||
      name === "mav.accountInfo.settings.holidaymode"
    ) {
      let splitString = name.split(".");

      let settingType = splitString[splitString.length - 1];

      this.setState(
        {
          ...this.state,
          mav: {
            ...this.state.mav,
            accountInfo: {
              ...this.state.mav.accountInfo,
              settings: {
                ...this.state.mav.accountInfo.settings,
                [settingType]: value,
              },
              baseLocation: {
                ...this.state.mav.accountInfo.baseLocation,
              },
            },
          },
        },
        inputChangeCallback
      );
    } else if (
      name === "mav.status" &&
      value === "preactivation" &&
      this.state.originalStatus !== "preactivation"
    ) {
      modal(adminMavCannotPreactivate);
    } else if (
      name === "mav.status" &&
      value === "resetting" &&
      this.state.originalStatus !== "resetting"
    ) {
      modal(adminMavCannotReset);
    } else if (name != "mav.accountInfo.terms") {
      if (name.split(".").length == 1) {
        oldValue = this.state[name];
        this.setState(
          {
            [name]: value,
          },
          inputChangeCallback
        );
      } else if (name.split(".").length == 2) {
        oldValue = this.state[name.split(".")[0]][name.split(".")[1]];

        this.setState(
          {
            [name.split(".")[0]]: {
              ...this.state[name.split(".")[0]],
              [name.split(".")[1]]: value,
            },
          },
          inputChangeCallback
        );
      } else if (name.split(".").length == 3) {
        oldValue =
          this.state[name.split(".")[0]][name.split(".")[1]][
            name.split(".")[2]
          ];
        this.setState(
          {
            [name.split(".")[0]]: {
              ...this.state[name.split(".")[0]],
              [name.split(".")[1]]: {
                ...this.state[name.split(".")[0]][name.split(".")[1]],
                [name.split(".")[2]]: value,
              },
            },
          },
          inputChangeCallback
        );
      } else if (name.split(".").length == 4) {
        oldValue =
          this.state[name.split(".")[0]][name.split(".")[1]][
            name.split(".")[2]
          ];
        this.setState(
          {
            [name.split(".")[0]]: {
              ...this.state[name.split(".")[0]],
              [name.split(".")[1]]: {
                ...this.state[name.split(".")[0]][name.split(".")[1]],
                [name.split(".")[2]]: {
                  ...this.state[name.split(".")[0]][name.split(".")[1]][
                    name.split(".")[2]
                  ],
                  [name.split(".")[3]]: value,
                },
              },
            },
          },
          inputChangeCallback
        );
      } else if (name.split(".").length == 5) {
        oldValue =
          this.state[name.split(".")[0]][name.split(".")[1]][
            name.split(".")[2]
          ];
        this.setState(
          {
            [name.split(".")[0]]: {
              ...this.state[name.split(".")[0]],
              [name.split(".")[1]]: {
                ...this.state[name.split(".")[0]][name.split(".")[1]],
                [name.split(".")[2]]: {
                  ...this.state[name.split(".")[0]][name.split(".")[1]][
                    name.split(".")[2]
                  ],
                  [name.split(".")[3]]: {
                    ...this.state[name.split(".")[0]][name.split(".")[1]][
                      name.split(".")[2]
                    ][name.split(".")[3]],
                    [name.split(".")[4]]: value,
                  },
                },
              },
            },
          },
          inputChangeCallback
        );
      }
    }
  }

  deleteMavAvatar(event) {
    if (event) {
      event.preventDefault();
    }

    this.setState({
      mav: {
        ...this.state.mav,
        accountInfo: {
          ...this.state.mav.accountInfo,
          avatar: "",
        },
      },
    });
  }

  handleCancelBan = () => {
    this.setState({ showModal: false }),
      this.setState({
        mav: { ...this.state.mav, status: this.state.originalStatus },
      });
  };

  handleConfirmBan = () => {
  };

  componentWillMount() {
    //
  }
  componentDidMount() {
    this.getMav();
  }
  componentWillUnmount() {
    //
  }

  render() {
    return (
      <div className="l-base-layout__content">
        <h1>Admin / Mav</h1>

        <div className="c-hr"></div>

        <div className="c-subheader-info-panel">
          <div className="c-subheader-info-panel__primary u-uppercase">
            ID: {this.state.mav.short_id}
          </div>
        </div>

        <div className="c-hr"></div>

        <div className="l-row">
          <div className="l-col-18">
            <div className="c-avatar">
              <div className="c-avatar__pic-wrap">
                {/* <img
                  src={
                    this.state.mav.accountInfo.avatar &&
                    this.state.mav.accountInfo.avatar != ""
                      ? serverUrl +
                        userImagesFolder +
                        "/" +
                        this.state.mav.short_id +
                        "/" +
                        this.state.mav.accountInfo.avatar +
                        imageFormat
                      : defaultAvatarImage
                  }
                  alt="avatar"
                  className="c-avatar__pic"
                  onError={(e) => { 
                    e.target.src = defaultAvatarImage;
                  }}
                /> */}
                <img
                  src={
                    this?.state?.mavImages?.imageKey
                      ? `${CDN}/${this.state.mavImages.imageKey}`
                      : defaultAvatarImage
                  }
                  alt={`mav image ${0 + 1}`}
                  className="c-avatar__pic mb-0 w-100 h-100 object-fit-cover"
                  onError={(e) => {
                    e.target.src = defaultAvatarImage;
                  }}
                />
              </div>
              {this?.state?.mavImages?.imageKey && (
                <button
                  value={this?.state?.mavImages}
                  onClick={(e) =>
                    this.deleteMavImage(e, this?.state?.mavImages?.imageKey)
                  }
                >
                  Delete Avatar
                </button>
              )}
            </div>
          </div>

          <div className="l-col-41">
            {this.state.mav.status && (
              <>
                <div className="c-checkbox-radio">
                  <input
                    type="radio"
                    id="pending"
                    name="mav.status"
                    value="preactivation"
                    onChange={this.handleInputChange}
                    checked={this.state.mav.status === "preactivation"}
                  />
                  <label htmlFor="pending">Pending</label>
                </div>
                <div className="c-checkbox-radio">
                  <input
                    type="radio"
                    id="active"
                    name="mav.status"
                    value="active"
                    onChange={this.handleInputChange}
                    checked={this.state.mav.status === "active"}
                  />
                  <label htmlFor="active">Active</label>
                </div>
                <div className="c-checkbox-radio">
                  <input
                    type="radio"
                    id="blocked"
                    name="mav.status"
                    value="blocked"
                    onChange={this.handleInputChange}
                    checked={this.state.mav.status === "blocked"}
                  />
                  <label htmlFor="blocked">Blocked</label>
                </div>
                <div className="c-checkbox-radio c-checkbox-radio--no-right-border">
                  <input
                    type="radio"
                    id="delete"
                    name="mav.status"
                    value="delete"
                    checked={this.state.mav.status === "delete"}
                  />
                  <label htmlFor="delete" className="cursor-default">
                    Delete
                  </label>
                </div>
              </>
            )}
            <div className="c-rating u-margin-left-xs u-margin-bottom-0 u-margin-top-l">
              <fieldset
                className="c-rating__wrap"
                onClick={(e) => {
                  const { mav } = this.state;
                  if (mav.totalRatings && mav.totalRatings > 0) {
                    toScreen(
                      e,
                      this.props.navigate,
                      `/mav/${mav.short_id}/reviews`,
                      false,
                      {
                        receiverId: mav?._id,
                        receiverShortId: mav?.short_id,
                        receiverType: mav?.userType,
                        userShortId1: "admin",
                        userShortId2: mav?.short_id,
                        username2: mav?.accountInfo?.username,
                        selectedPage:
                          window.history.state.usr?.selectedPage ?? 1,
                        selectedFilter:
                          window.history.state.usr?.selectedFilter ??
                          defaultMessagesFilter,
                        previousPath:
                          window.history.state.usr?.previousPath ??
                          window.location.pathname,
                      }
                    );
                  }
                }}
              >
                {[5, 4, 3, 2, 1].map((star) => (
                  <React.Fragment key={star}>
                    <input
                      tabIndex="-1"
                      className="c-rating__input"
                      type="radio"
                      id={`star${star}`}
                      name="stars"
                      value={star}
                      checked={this.state.mav.ratingAsMav === star}
                      readOnly
                    />
                    <label
                      className="c-rating__label-read-only"
                      htmlFor={`star${star}`}
                    >
                      <span className="u-visually-hidden">{`${star} star${
                        star > 1 ? "s" : ""
                      }`}</span>
                    </label>
                  </React.Fragment>
                ))}
              </fieldset>
            </div>

            <div className="u-margin-left-s">
              {this.state.mav.totalRatings == 0 ||
              this.state.mav.totalRatings == "" ? (
                <p className="c-rating__subtext">(No reviews yet)</p>
              ) : (
                <button
                  className="pl-0"
                  // href={
                  //   this.state.mav.totalRatings &&
                  //   this.state.mav.totalRatings > 0
                  //     ? `/mav/${this.state.mav.short_id}/reviews`
                  //     : "#"
                  // }
                  onClick={(e) => {
                    this.state.mav.totalRatings &&
                    this.state.mav.totalRatings > 0
                      ? toScreen(
                          e,
                          this.props.navigate,
                          "/mav/" + this.state.mav.short_id + "/reviews",
                          false,
                          {
                            receiverId: this.state.mav?._id,
                            receiverShortId: this.state.mav?.short_id,
                            receiverType: this.state.mav?.userType,
                            userShortId1: "admin",
                            userShortId2: this.state.mav?.short_id,
                            username2: this.state.mav?.accountInfo?.username,
                            selectedPage:
                              window.history.state.usr?.selectedPage ?? 1,
                            selectedFilter:
                              window.history.state.usr?.selectedFilter ??
                              defaultMessagesFilter,
                            previousPath:
                              window.history.state.usr?.previousPath ??
                              window.location.pathname,
                          }
                        )
                      : null;
                  }}
                >
                  View {this.state.mav.totalRatings} driver reviews
                </button>
              )}
            </div>
          </div>

          <div className="l-col-41">
            {this.state.mav.status && this.state.mav.status !== "delete" && (
              <>
                <button
                  className="c-btn c-btn--small c-btn--full-width u-margin-bottom-xs c-btn--red"
                  onClick={(e) => this.saveMav(e)}
                >
                  Save Changes
                </button>
                <button
                  className="c-btn c-btn--small c-btn--full-width u-margin-bottom-xs  c-btn--grey"
                  onClick={(e) => this.discardChanges(e)}
                >
                  Discard Changes
                </button>
                <button
                  className="c-btn c-btn--small c-btn--full-width  c-btn--green"
                  onClick={(e) =>
                    toScreen(
                      e,
                      this.props.navigate,
                      "/message/" + this.state.mav.short_id,
                      false,
                      {
                        receiverId: this.state.mav?._id,
                        receiverShortId: this.state.mav?.short_id,
                        receiverType: this.state.mav?.userType,
                        userShortId1: "admin",
                        userShortId2: this.state.mav?.short_id,
                        username2: this.state.mav?.accountInfo?.username,
                        selectedPage:
                          window.history.state.usr?.selectedPage ?? 1,
                        selectedFilter:
                          window.history.state.usr?.selectedFilter ??
                          defaultMessagesFilter,
                        previousPath:
                          window.history.state.usr?.previousPath ??
                          window.location.pathname,
                      }
                    )
                  }
                >
                  Contact MAV
                </button>
              </>
            )}
          </div>
        </div>

        <div className="c-hr"></div>

        <div className="l-row">
          <div className="l-col-66">
            <form action="">
              <div className="c-input-wide">
                <label className="c-input-wide__label">First name:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.firstname}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.firstname"
                  placeholder="First name"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">Surname:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.surname}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.surname"
                  placeholder="Surname"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">Username:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.username}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.username"
                  placeholder="Username"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">Email:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.email}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.email"
                  placeholder="Email"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">Telephone:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.telephone}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.telephone"
                  placeholder="Telephone"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  Driving Licence No:
                </label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.drivingLicence}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.drivingLicence"
                  placeholder="Driving Licence Number"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  Licence Check Code:
                </label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.licenceCheckCode}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.licenceCheckCode"
                  placeholder="Driving Licence Check Code"
                  className="c-input-wide__input"
                />
              </div>

              <div className="c-input-wide">
                <div className="c-input-wide__label">T-Shirt Size:</div>
                <select
                  className="c-input-wide__input"
                  value={this.state.mav.tshirtSize}
                  onChange={this.handleInputChange}
                  name="mav.tshirtSize"
                >
                  <option value="">Please select</option>
                  <option value="small">Small</option>
                  <option value="medium">Medium</option>
                  <option value="Large">Large</option>
                  <option value="xlarge">X Large</option>
                  <option value="xxlarge">XX Large</option>
                </select>
              </div>

              <br />
              <h4>Address :</h4>
              <div className="c-input-wide d-flex">
                <label className="c-input-wide__label">
                  Base location:
                  {this.state.loaders.baseLocation ? (
                    <div className="c-input-wide__loader" />
                  ) : null}
                </label>

                <input
                  list="addressSuggestion"
                  type="text"
                  value={
                    this.state.mav.accountInfo.baseLocation.homeaddress
                      .formattedAddress
                  }
                  onFocus={(e) => {
                    this.addressAutoComplete(e, "homeaddress");
                  }}
                  onBlur={(e) => {
                    this.checkAddress(e, "homeaddress");
                  }}
                  onChange={(e) => {
                    this.handleInputChange(e, () => {
                      this.addressAutoComplete(e, "homeaddress");
                    });
                  }}
                  name="mav.accountInfo.baseLocation.homeaddress.formattedAddress"
                  placeholder="Base location"
                  className="c-input-wide__input"
                  autoComplete="off"
                />

                <datalist id="addressSuggestion">
                  {_.size(this.state.addressSuggestions.homeaddress) > 0
                    ? Object.keys(
                        this.state.addressSuggestions.homeaddress
                      ).map((key) => {
                        return this.renderMyAddresses(key, "homeaddress");
                      })
                    : null}
                </datalist>
              </div>

              {/* 
							================================================
							Newly added fields 20210920 By MWays 
							================================================
							*/}

              <div className="c-input-wide">
                <label className="c-input-wide__label">Address Line 1:</label>
                <input
                  type="text"
                  value={
                    this.state.mav.accountInfo.baseLocation.homeaddress
                      .addressLine1
                  }
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.baseLocation.homeaddress.addressLine1"
                  placeholder="Address Line 1"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">Address Line 2:</label>
                <input
                  type="text"
                  value={
                    this.state.mav.accountInfo.baseLocation.homeaddress
                      .addressLine2
                  }
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.baseLocation.homeaddress.addressLine2"
                  placeholder="Address Line 2"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide d-flex">
                <label className="c-input-wide__label">
                  PostCode:
                  {this.state.loaders.postCode ? (
                    <div className="c-input-wide__loader" />
                  ) : null}
                </label>
                <input
                  type="text"
                  value={
                    this.state.mav.accountInfo.baseLocation.homeaddress.postCode
                  }
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.baseLocation.homeaddress.postCode"
                  placeholder="Post Code"
                  className="c-input-wide__input"
                />
              </div>

              <div className="c-input-wide d-flex">
                <label className="c-input-wide__label">
                  County:
                  {this.state.loaders.couty ? (
                    <div className="c-input-wide__loader" />
                  ) : null}
                </label>
                <input
                  list="countySuggestion"
                  type="text"
                  value={
                    this.state.mav.accountInfo.baseLocation.homeaddress
                      .countyName
                  }
                  onFocus={(e) => {
                    this.countyAutoComplete(e, "countyName");
                  }}
                  onBlur={(e) => {
                    this.checkCounty(e, "countyName");
                  }}
                  onChange={(e) => {
                    this.handleInputChange(e, () => {
                      this.countyAutoComplete(e, "countyName");
                    });
                  }}
                  name="mav.accountInfo.baseLocation.homeaddress.countyName"
                  placeholder="County"
                  className="c-input-wide__input"
                  autoComplete="off"
                />
                <datalist id="countySuggestion">
                  {_.size(this.state.countiesFound) > 0
                    ? Object.keys(this.state.countiesFound).map((key) => {
                        return this.renderCounties(key, "county");
                      })
                    : null}
                </datalist>
              </div>

              <div className="c-input-wide d-flex">
                <label className="c-input-wide__label">
                  City:
                  {this.state.loaders.city ? (
                    <div className="c-input-wide__loader" />
                  ) : null}
                </label>
                <input
                  list="citySuggestion"
                  type="text"
                  value={
                    this.state.mav.accountInfo.baseLocation.homeaddress.cityName
                  }
                  onFocus={(e) => {
                    this.cityAutoComplete(e, "cityName");
                  }}
                  onBlur={(e) => {
                    this.checkCity(e, "cityName");
                  }}
                  onChange={(e) => {
                    this.handleInputChange(e, () => {
                      this.cityAutoComplete(e, "city");
                    });
                  }}
                  name="mav.accountInfo.baseLocation.homeaddress.cityName"
                  placeholder="City"
                  className="c-input-wide__input"
                  autoComplete="off"
                />

                <datalist id="citySuggestion">
                  {_.size(this.state.citiesFound) > 0
                    ? Object.keys(this.state.citiesFound).map((key) => {
                        return this.renderCities(key);
                      })
                    : null}
                </datalist>
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">Range:</label>
                <div className="c-input-wide__slider range-slider-main">
                  <ReactSlider
                    className="horizontal-slider mav-range"
                    thumbClassName="thumb"
                    trackClassName="track"
                    min={50}
                    max={200}
                    value={this.state.mav.accountInfo.baseLocation.radius}
                    onChange={(e) => this.handleSliderChange(e)}
                    renderThumb={(props, state) => (
                      <div {...props}>
                        <span>
                          {state.valueNow === 200
                            ? "National"
                            : `${state.valueNow} miles`}
                        </span>
                      </div>
                    )}
                  />
                  {/* <Slider
                    min={50}
                    max={200}
                    format={(e) => {
                      if (e == 200) {
                        return "National";
                      } else {
                        return e + " miles";
                      }
                    }}
                    value={this.state.mav.accountInfo.baseLocation.radius}
                    orientation="horizontal"
                    onChange={(e) => {
                      this.handleSliderChange(e);
                    }}
                  /> */}
                </div>
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  Stripe account ID:
                </label>
                <span>
                  {this.state.mav.stripeAccountId &&
                  this.state.mav.stripeAccountId != "" ? (
                    <a
                      href={
                        "https://dashboard.stripe.com/connect/accounts/" +
                        this.state.mav.stripeAccountId
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {this.state.mav.stripeAccountId}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </span>
              </div>

              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="earlyadopter"
                  onChange={this.handleInputChange}
                  name="mav.earlyAdopter"
                  checked={this.state.mav.earlyAdopter}
                />
                <label className="c-input-wide__label" htmlFor="earlyadopter">
                  Early Adopter:
                </label>
              </div>

              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="hiddenFromApi"
                  onChange={this.handleInputChange}
                  name="mav.hiddenFromApi"
                  checked={this.state.mav.hiddenFromApi}
                />
                <label className="c-input-wide__label" htmlFor="hiddenFromApi">
                  Hidden from API:
                </label>
              </div>

              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="mav.accountInfo.terms"
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.terms"
                  checked={this.state.mav.accountInfo.terms}
                />
                <label
                  className="c-input-wide__label"
                  htmlFor="mav.accountInfo.terms"
                >
                  Terms agreed:
                </label>
              </div>

              {/* 
							================================================
							Newly added fields 20210920 By MWays  22222
							================================================
							*/}

              <br />
              <h4>Documents Attached:</h4>
              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  Utility Bill Copy:
                </label>
                <span>
                  <b>
                    {this.state.mav.utilitybillCopy &&
                    this.state.mav.utilitybillCopy != "" ? (
                      <a href={this.state.mav.utilitybillCopy} target="_blank" rel="noopener noreferrer">
                        Utility Bill Copy{" "}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </b>
                </span>
                <input
                  id="utilitybillCopyPicker"
                  type="file"
                  accept="image/*, application/pdf"
                  className="u-margin-left-s"
                  onChange={this.handleFileSelect}
                  name="utilitybillCopyPicker"
                />
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  Van Insurance Copy:
                </label>
                <span>
                  <b>
                    {this.state.mav.vaninsuranceCopy &&
                    this.state.mav.vaninsuranceCopy != "" ? (
                      <a href={this.state.mav.vaninsuranceCopy} target="_blank" rel="noopener noreferrer">
                        Van Insurance Copy{" "}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </b>
                </span>
                <input
                  id="utilitybillCopyPicker"
                  type="file"
                  accept="image/*, application/pdf"
                  className="u-margin-left-s"
                  onChange={this.handleFileSelect}
                  name="vaninsuranceCopyPicker"
                />
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  WasteH Licence Copy:
                </label>
                <span>
                  <b>
                    {this.state.mav.accountInfo.wasteHandlingLicenceCopy &&
                    this.state.mav.accountInfo.wasteHandlingLicenceCopy !=
                      "" ? (
                      <a
                        href={
                          this.state.mav.accountInfo.wasteHandlingLicenceCopy
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Waste Handling Licence Copy{" "}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </b>
                </span>
                <input
                  id="utilitybillCopyPicker"
                  type="file"
                  accept="image/*, application/pdf"
                  className="u-margin-left-s"
                  onChange={this.handleFileSelect}
                  name="wasteHandlingLicenceCopyPicker"
                />
              </div>

              <br />
              <h4>Van Details:</h4>

              <div className="c-input-wide">
                <label className="c-input-wide__label">Van Make:</label>
                <input
                  type="text"
                  value={this.state.mav.vanMake}
                  onChange={this.handleInputChange}
                  name="mav.vanMake"
                  placeholder="Van Make"
                  className="c-input-wide__input"
                />
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">Van Model:</label>
                <input
                  type="text"
                  value={this.state.mav.vanModel}
                  onChange={this.handleInputChange}
                  name="mav.vanModel"
                  placeholder="Van Model"
                  className="c-input-wide__input"
                />
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">Van Year:</label>
                <input
                  type="text"
                  value={this.state.mav.vanYear}
                  onChange={this.handleInputChange}
                  name="mav.vanYear"
                  placeholder="Van Year"
                  className="c-input-wide__input"
                />
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label">
                  Vehicle Reg. Number:
                </label>
                <input
                  type="text"
                  value={this.state.mav.vanRegNumber}
                  onChange={this.handleInputChange}
                  name="mav.vanRegNumber"
                  placeholder="Vehicle Reg. Number"
                  className="c-input-wide__input"
                />
              </div>

              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="mav.vanStickers"
                  onChange={this.handleInputChange}
                  name="mav.vanStickers"
                  checked={this.state.mav.vanStickers}
                />
                <label
                  className="c-input-wide__label"
                  htmlFor="mav.vanStickers"
                >
                  Need Van Stickers ?
                </label>
              </div>

              <br />
              <h4>Company Details:</h4>

              <div className="c-input-wide">
                <label className="c-input-wide__label">Company Name:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.companyName}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.companyName"
                  placeholder="Company Name"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">VAT Number:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.vatNumber}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.vatNumber"
                  placeholder="VAT Number"
                  className="c-input-wide__input"
                />
              </div>
              <div className="c-input-wide">
                <label className="c-input-wide__label">Waste/H Licence:</label>
                <input
                  type="text"
                  value={this.state.mav.accountInfo.wasteHandlingLicence}
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.wasteHandlingLicence"
                  placeholder="Waste Handling Licence"
                  className="c-input-wide__input"
                />
              </div>

              <br />
              <h4>Insurance Status:</h4>

              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="mav.accountInfo.publicLiabilityInsurance"
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.publicLiabilityInsurance"
                  checked={this.state.mav.accountInfo.publicLiabilityInsurance}
                />
                <label
                  className="c-input-wide__label"
                  htmlFor="mav.accountInfo.publicLiabilityInsurance"
                >
                  Public Liability:
                </label>
              </div>

              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="mav.accountInfo.goodsInTransitInsurance"
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.goodsInTransitInsurance"
                  checked={this.state.mav.accountInfo.goodsInTransitInsurance}
                />
                <label
                  className="c-input-wide__label"
                  htmlFor="mav.accountInfo.goodsInTransitInsurance"
                >
                  Goods In Transit:
                </label>
              </div>
              <div className="c-input-wide c-input-wide--checkbox">
                <input
                  type="checkbox"
                  className="c-input-wide__checkbox-radio-input"
                  id="mav.accountInfo.generalVanInsurance"
                  onChange={this.handleInputChange}
                  name="mav.accountInfo.generalVanInsurance"
                  checked={this.state.mav.accountInfo.generalVanInsurance}
                />
                <label
                  className="c-input-wide__label"
                  htmlFor="mav.accountInfo.generalVanInsurance"
                >
                  General Van:
                </label>
              </div>

              <br />
              <h4>Notification Settings:</h4>

              <div className="c-input-wide">
                <label className="c-input-wide__label-alt">
                  Push notifications :
                </label>
                <span className="c-input-wide__copy-alt">
                  <input
                    type="checkbox"
                    className="c-toggle-switch-small__input"
                    name="mav.accountInfo.settings.pushnotifications"
                    id="mav.accountInfo.settings.pushnotifications"
                    onChange={this.handleInputChange}
                    checked={
                      this.state.mav.accountInfo.settings.pushnotifications ===
                      true
                    }
                  />
                  <label
                    htmlFor="mav.accountInfo.settings.pushnotifications"
                    className="c-toggle-switch-small__label"
                  >
                    <span className="u-visually-hidden">
                      Push notifications
                    </span>
                  </label>
                </span>
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label-alt">
                  Email notifications :
                </label>
                <span className="c-input-wide__copy-alt">
                  <input
                    type="checkbox"
                    className="c-toggle-switch-small__input"
                    name="mav.accountInfo.settings.emailnotifications"
                    id="mav.accountInfo.settings.emailnotifications"
                    onChange={this.handleInputChange}
                    checked={
                      this.state.mav.accountInfo.settings.emailnotifications ===
                      true
                    }
                  />
                  <label
                    htmlFor="mav.accountInfo.settings.emailnotifications"
                    className="c-toggle-switch-small__label"
                  >
                    <span className="u-visually-hidden">
                      Email notifications
                    </span>
                  </label>
                </span>
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label-alt">
                  Marketing notifications :
                </label>
                <span className="c-input-wide__copy-alt">
                  <input
                    type="checkbox"
                    className="c-toggle-switch-small__input"
                    name="mav.accountInfo.settings.marketingnotifications"
                    id="mav.accountInfo.settings.marketingnotifications"
                    onChange={this.handleInputChange}
                    checked={
                      this.state.mav.accountInfo.settings
                        .marketingnotifications === true
                    }
                  />
                  <label
                    htmlFor="mav.accountInfo.settings.marketingnotifications"
                    className="c-toggle-switch-small__label"
                  >
                    <span className="u-visually-hidden">
                      Marketing notifications
                    </span>
                  </label>
                </span>
              </div>

              <div className="c-input-wide">
                <label className="c-input-wide__label-alt">
                  Holiday mode :
                </label>
                <span className="c-input-wide__copy-alt">
                  <input
                    type="checkbox"
                    className="c-toggle-switch-small__input"
                    name="mav.accountInfo.settings.holidaymode"
                    id="mav.accountInfo.settings.holidaymode"
                    onChange={this.handleInputChange}
                    checked={
                      this.state.mav.accountInfo.settings.holidaymode === true
                    }
                  />
                  <label
                    htmlFor="mav.accountInfo.settings.holidaymode"
                    className="c-toggle-switch-small__label"
                  >
                    <span className="u-visually-hidden">Holiday mode</span>
                  </label>
                </span>
              </div>
            </form>
          </div>

          <div className="l-col-33">
            <AuditNotes
              ref="auditNotes"
              notes={this.state.mav.notes}
              updateNotes={this.updateNotes}
            />
          </div>
        </div>

        <div className="l-row l-row">
          <div className="l-col-100">
            <h2 className="u-margin-bottom-0">Quotes</h2>
          </div>
        </div>

        <div className="c-hr"></div>

        {_.size(this.state.mav?.quotes) > 0 ? (
          <>
            <div className="l-row">
              <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
                {/* <div className="filter-bar">
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="all"
                      name="filter"
                      value="all"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "all"}
                    />
                    <label htmlFor="all">All ({this.state.totals.total})</label>
                  </div>
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="open"
                      name="filter"
                      value="open"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "open"}
                    />
                    <label htmlFor="open">
                      Open ({this.state.totals.open})
                    </label>
                  </div>
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="paid"
                      name="filter"
                      value="paid"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "paid"}
                    />
                    <label htmlFor="paid">
                      Paid ({this.state.totals.paid})
                    </label>
                  </div>
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="complete"
                      name="filter"
                      value="complete"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "complete"}
                    />
                    <label htmlFor="complete">
                      Complete ({this.state.totals.complete})
                    </label>
                  </div>
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="closed"
                      name="filter"
                      value="closed"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "closed"}
                    />
                    <label htmlFor="closed">
                      Closed ({this.state.totals.closed})
                    </label>
                  </div>
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="refund"
                      name="filter"
                      value="refund"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "refund"}
                    />
                    <label
                      htmlFor="refund"
                      className={
                        this.state.totals.refund && this.state.totals.refund > 0
                          ? "u-color-red"
                          : null
                      }
                    >
                      Refund Requested ({this.state.totals.refund})
                    </label>
                  </div>
                  <div className="c-checkbox-radio-block">
                    <input
                      type="radio"
                      id="transferneeded"
                      name="filter"
                      value="transferneeded"
                      onChange={this.handleInputChange}
                      checked={this.state.filter === "transferneeded"}
                    />
                    <label
                      htmlFor="transferneeded"
                      className={
                        this.state.totals.transferneeded &&
                          this.state.totals.transferneeded > 0
                          ? "u-color-red"
                          : null
                      }
                    >
                      Transfer Needed ({this.state.totals.transferneeded})
                    </label>
                  </div>
                </div> */}
              </div>

              <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
                {/* <div className="c-pagination">
                  <button
                    type="button"
                    className="c-pagination__prev"
                    onClick={(e) => this.prevPage(e)}
                  >
                    &lt;&lt; Prev
                  </button>

                  <div className="c-pagination__quotes"></div>
                  <div className="c-pagination__page-count">
                    {this.state.pagination.page} / {this.state.pagination.total}
                  </div>

                  <button
                    type="button"
                    className="c-pagination__next"
                    onClick={(e) => this.nextPage(e)}
                  >
                    Next &gt;&gt;
                  </button>
                </div> */}
                <div className="c-hr u-margin-bottom-0"></div>

                <div className="c-list-entry c-list-entry__header">
                  <div className="c-list-entry__rating c-list-filter">
                    <button
                      // className={
                      //   this.state.sort == '{"jobSpec.status":-1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort == '{"jobSpec.status":1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "status")}
                      className="p-0 cursor-default"
                    >
                      Status
                    </button>
                  </div>
                  <div className="c-list-entry__amount c-list-filter">
                    <button
                      className="p-0 cursor-default"
                      // className={
                      //   this.state.sort == '{"quotes":-1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort == '{"quotes":1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "quotes")}
                    >
                      Amount
                    </button>
                  </div>

                  <div className="c-list-entry__created c-list-filter">
                    <button
                      // className={
                      //   this.state.sort == '{"creationDate":-1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort == '{"creationDate":1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "created")}
                      className="p-0 cursor-default"
                    >
                      Created
                    </button>
                  </div>
                  <div className="c-list-entry__btn pr-15">
                    <button
                      type="button"
                      className="c-btn c-btn--small me-0 disable-btn"
                    >
                      {" "}
                      View Job{" "}
                    </button>
                  </div>
                  <div className="c-list-entry__rating c-list-filter ml-32">
                    <button
                      // className={
                      //   this.state.sort ==
                      //     '{"jobSpec.serviceType":1,"jobSpec.serviceType":1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort ==
                      //       '{"jobSpec.serviceType":-1,"jobSpec.serviceType":-1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "jobtype")}
                      className="p-0 cursor-default"
                    >
                      Job Type
                    </button>
                  </div>
                  <div className="c-list-entry__created c-list-filter">
                    <button
                      className="p-0 cursor-default"
                      // className={
                      //   this.state.sort ==
                      //     '{"jobSpec.dateAndTime.standardDate":1,"jobSpec.standardDate":1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort ==
                      //       '{"jobSpec.dateAndTime.standardDate":-1,"jobSpec.standardDate":-1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "jobdate")}
                    >
                      Job Date
                    </button>
                  </div>
                  <div className="c-list-entry__location c-list-filter">
                    <button
                      // className={
                      //   this.state.sort ==
                      //     '{"originAddress.formattedAddress":-1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort ==
                      //       '{"originAddress.formattedAddress":1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "location")}
                      className="p-0 cursor-default"
                    >
                      Location
                    </button>
                  </div>
                  <div className="c-list-entry__created c-list-filter">
                    <button
                      // className={
                      //   this.state.sort == '{"creationDate":-1}'
                      //     ? "c-list-filter__button c-list-filter__button--icon-up"
                      //     : this.state.sort == '{"creationDate":1}'
                      //       ? "c-list-filter__button c-list-filter__button--icon-down"
                      //       : "c-list-filter__button c-list-filter__button--faded"
                      // }
                      // onClick={(e) => this.sortJobs(e, "created")}
                      className="p-0 cursor-default"
                    >
                      Created
                    </button>
                  </div>
                  <div className="c-list-entry__btn">
                    <button
                      type="button"
                      className="c-btn c-btn--small me-0 disable-btn"
                    >
                      {" "}
                      View Quotes{" "}
                    </button>
                  </div>
                </div>
                <div>
                  {/* {Object.keys(this.state?.client?.jobs)?.map(this.renderJobs)} */}
                </div>
                <div className="c-hr u-margin-bottom-0"></div>
                {/* <div className="c-pagination">
                  <button
                    type="button"
                    className="c-pagination__prev"
                    onClick={(e) => this.prevPage(e)}
                  >
                    &lt;&lt; Prev
                  </button>
                  {this.state.pagination.page} / {this.state.pagination.total}
                  <button
                    type="button"
                    className="c-pagination__next"
                    onClick={(e) => this.nextPage(e)}
                  >
                    Next &gt;&gt;
                  </button>
                </div> */}
              </div>
            </div>
            <div className="l-row">
              <div className="l-col-100 ">
                {Object.keys(this.state.mav.quotes).map(this.renderQuotes)}
              </div>
            </div>
          </>
        ) : (
          <span className="text-danger mt-16">No quotes for this MAV.</span>
        )}

        {/* Ban driver Modal */}
        {/* 
        {this.state.showModal && (
          <div className="ban-modal-backdrop" onClick={() => { this.handleCancelBan() }}>
            <div
              className="ban-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ban-modal-header">
                <h2>Confirm driver ban</h2>
                <p>
                  This driver has the following booked jobs. Banning the driver
                  will cancel these jobs.
                </p>

              </div>
              <div className="ban-modal-body">
                {this.state.jobs?.map((job) => (
                  <div className="job-card" key={job?.id}>
                    <div className="job-details">
                      <h4>
                        {job?.from}
                        <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M0.688 5.784V4.12H4.624V5.784H0.688ZM10.3845 9.272L9.2645 8.008L11.6645 5.896H5.9525V4.04H11.6645L9.2645 1.928L10.3845 0.664L14.8325 4.936V5L10.3845 9.272Z" fill="#5A5A5A" />
                        </svg>
                        {job?.to}
                      </h4>
                      <span>
                        <span className="u-before-icon-calendar">
                          &nbsp;{job?.date}
                        </span>&nbsp;&nbsp;
                        <span className="u-before-icon-clock">
                          &nbsp; {job?.time}
                        </span>&nbsp;&nbsp;
                        <span className="u-before-icon-dollor ">
                          &nbsp;{job?.price}
                        </span>

                      </span>
                    </div>
                    <button
                      type="button"
                      className="view-btn-ban"
                      onClick={(e) =>
                        toScreen(e, this.props.navigate,
                          "/job/TPEPTYV9N",)
                      }
                    >
                      View
                    </button>
                  </div>
                ))}
              </div>
              <div className="ban-modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => { this.handleCancelBan() }}
                >
                  Cancel
                </button>
                <button className="btn btn-danger"
                  onClick={() => this.handleConfirmBan()}
                >
                  Confirm ban
                </button>
              </div>
            </div>
          </div>
        )} */}
      </div>
    );
  }
}

Mav.contextTypes = {
  router: PropTypes.object,
};

Mav.propTypes = {
  userDetails: PropTypes.object.isRequired,
  mavId: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(Mav);
